import { RotasComBarra } from 'enum';
import {
  Col,
  Container,
  Row,
  ThreeDotsLoader,
} from 'plataforma-fundacao-componentes';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUrlCrescerNaPratica } from 'services/Api';

export default function CrescerNaPratica() {
  const navigate = useNavigate();

  const handleRedirect = useCallback(async () => {
    const AcceptedUrl = /^(.)+\/registro\/(.+)$/i;
    try {
      const { data } = await getUrlCrescerNaPratica();

      if (AcceptedUrl.test(data)) {
        const to = data.replace(AcceptedUrl, '/$2');
        navigate(to, { replace: true });
      }
    } catch (err) {
      navigate(RotasComBarra.naoEncontrado);
    }
  }, [navigate]);

  useEffect(() => {
    handleRedirect();
  }, [handleRedirect]);

  return (
    <Container verticalPadding>
      <Row>
        <Col centralized>
          <ThreeDotsLoader />
        </Col>
      </Row>
    </Container>
  );
}
